import React from "react";
import "./radio-group.scss";
import { Field } from "formik";
import classNames from "classnames";
import { FormikMuiRadioGroup } from "./FormikMuiRadioGroup";
import {
  RadioButtonOption,
  RadioButton,
} from "@thrivetribe/mvf.ui.atoms.radio-button";
import { ValidationError } from "@thrivetribe/mvf.ui.atoms.validation-error";

export type RadioGroupProps = {
  options: RadioButtonOption[];
  name: string;
  errorMessage?: string;
};

export function RadioGroup({ name, options, errorMessage }: RadioGroupProps) {
  return (
    <div className={classNames("radio-group", { invalid: errorMessage })}>
      <Field component={FormikMuiRadioGroup} name={name}>
        {options.map((option, index) => (
          <RadioButton option={option} tabIndex={index + 1} key={index} />
        ))}
      </Field>
      {errorMessage && <ValidationError errorMessage={errorMessage} />}
    </div>
  );
}
